<template>
  <div>
      <nav class="navbar navbar-default navbar-fixed-top">
        <div class="container-fluid">
          <!-- Brand and toggle get grouped for better mobile display -->
          <div class="navbar-header">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <router-link to="/" class="navbar-brand"><img src="https://ballotpedia.org/wiki/skins/BallotpediaBootstrap/images/bp-logo.svg" class="logo"> <span class="subline">Data</span></router-link> 
          </div>
          <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
            <ul class="nav navbar-nav navbar-right">
            </ul>
          </div>
        </div>
      </nav>
      <div class="container home-container">
        <div class="row">
          <div class="col-xs-12 col-md-4 col-md-offset-4">
            <div class="form-container">
            <img src="https://ballotpedia.org/wiki/skins/BallotpediaBootstrap/images/bp-logo.svg" class="logo-small">
              <form class="form">
                <div class="form-group">
                  <input type="email" class="form-control" placeholder="Email" v-model="email">
                </div>
                <div class="form-group">
                  <input type="password" class="form-control" placeholder="Password" v-model="password">
                </div>
                <button type="button" v-on:click="login" class="btn btn-default login-btn">Login</button>
                <p v-if="loginSuccessful === false" class="invalid-login">Invalid email or password.</p>
                <div v-if="loading" class="fa-3x login-load" >
                  <i class="fas fa-spinner fa-spin"></i>
                </div>
                <!-- <router-link to="/dashboard" class="reset-link">Forgot Password?</router-link> -->
              </form>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>


<script>
  export default {
    name: 'Home',
    data: function () {
    return {
        email: null,
        password: null,
        loginSuccessful: null,
        loading: false
    } 
    },
    methods: {
      async login() {
        this.loading = true;

        // Validate Username & Pass
        let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/data_clients_users/login`, {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              credentials: 'include',
              body: JSON.stringify({
                email: this.email,
                password: this.password
              })
          })
          
        response = await response.json();
    
        
        this.loginSuccessful = response.success;

        if (response.success) {


          // Call backend again to tell it to generate Token, Store in DB, then return the command to set the cookie
          let refreshResponse = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/data_clients_users/xsrf_refresh`, {
        
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({})
          })
            await refreshResponse.json();
            this.$router.push({ path: '/dashboard' });
          }

          this.loading = false;
      },

      
    }
  }

</script>



<style scoped>
.home-container{
  margin-top: 200px;
}
.form-container {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 40px;
  background: white;
}
.logo-small {
  width: 150px;
  margin: 0 auto;
  margin-bottom: 20px;
}
.login-btn {
  width: 100%;
  background: #334AAB;
  color: white;
  font-weight: 700;
}
.reset-link {
  padding-top: 20px;
}

.login-load {
  margin-top: 10px;
  font-size: 20px;
}
</style>
